// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__f-gom","meals-appear":"AvailableMeals_meals-appear__JorUL"};